import ClientQuickInfoModal from './ClientQuickInfoModal';

export default ClientQuickInfoModal;
